module.exports = __webpack_public_path__ + "static/media/research_banner.a6b716d3.jpg";